/* eslint-disable react/prop-types */
import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Chip,
  Button,
} from "@material-ui/core";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import moment from "moment";

const MediaItem = ({ media, index, prefix }) => {
  const type = (media.mediaType || "").toLowerCase();
  if (type === "video") {
    return (
      <Box style={{ borderRadius: 8, overflow: "hidden", background: "#000" }}>
        <video
          src={media.url}
          controls
          style={{ width: "100%", height: 140, objectFit: "cover", display: "block" }}
        />
        <Typography variant="caption" style={{ display: "block", padding: "4px 6px", color: "#ccc", background: "#111", fontSize: 11 }}>
          {media.name || `${prefix}-${index}`}
        </Typography>
      </Box>
    );
  }
  return (
    <img
      src={media.url}
      alt={media.name || `${prefix}-${index}`}
      style={{ width: "100%", height: 140, objectFit: "cover", borderRadius: 8, border: "1px solid #eee", display: "block" }}
    />
  );
};

const InfoRow = ({ label, value }) => (
  <Grid container style={{ marginBottom: 10 }}>
    <Grid item xs={4} sm={3}>
      <Typography style={{ fontWeight: 600, fontSize: 14, color: "#555" }}>{label}</Typography>
    </Grid>
    <Grid item xs={8} sm={9}>
      <Typography style={{ fontSize: 14 }}>{value !== null && value !== undefined && value !== "" ? value : "N/A"}</Typography>
    </Grid>
  </Grid>
);

const ViewPortfolio = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { portfolio, userId } = state || {};

  // Normalize: API may return a single object OR an array for media fields
  const normalizeMedia = (val) => {
    if (!val) return [];
    if (Array.isArray(val)) return val.filter(Boolean);
    if (typeof val === "object" && val.url) return [val];
    return [];
  };

  const mediaItems = normalizeMedia(portfolio?.mediaUrls).length
    ? normalizeMedia(portfolio?.mediaUrls)
    : normalizeMedia(portfolio?.media);
  const coverItems = normalizeMedia(portfolio?.coverUrls).length
    ? normalizeMedia(portfolio?.coverUrls)
    : normalizeMedia(portfolio?.coverImages);

  if (!portfolio) {
    return (
      <Container maxWidth={false} disableGutters style={{ margin: "0 2%" }}>
        <Typography>No portfolio data found.</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth={false} disableGutters style={{ margin: "0 2%", minHeight: "70vh" }}>
      {/* Breadcrumb */}
      <Typography style={{ fontWeight: "bold", display: "flex", alignItems: "center", flexWrap: "wrap", marginBottom: 16 }}>
        <Link to="/admin/user" style={{ color: "black", textDecoration: "none", marginRight: 4 }}>Users</Link>
        &gt;
        <span
          style={{ cursor: "pointer", marginLeft: 4, marginRight: 4 }}
          onClick={() => navigate("/admin/user/view-user", { state: { id: userId } })}
        >
          View User
        </span>
        &gt;
        <span style={{ fontWeight: "bold", marginLeft: 4 }}>Portfolio Detail</span>
      </Typography>

      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        style={{ marginBottom: 16 }}
        variant="outlined"
        size="small"
      >
        Back
      </Button>

      {/* Detail Card */}
      <Box style={{ background: "#fff", borderRadius: 8, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.1)" }}>
        <Typography variant="h6" style={{ fontWeight: 700, marginBottom: 16 }}>
          {portfolio.title || "Portfolio Detail"}
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <InfoRow label="Title" value={portfolio.title} />
            <InfoRow label="Visibility" value={portfolio.visibility} />
            <InfoRow label="Likes" value={portfolio.likeCount} />
            <InfoRow label="Comments" value={portfolio.commentCount} />
            <InfoRow label="Active" value={portfolio.isActive ? "Yes" : "No"} />
            <InfoRow label="Created At" value={portfolio.createdAt ? moment(portfolio.createdAt).format("DD/MM/YYYY HH:mm") : null} />
            <InfoRow label="Updated At" value={portfolio.updatedAt ? moment(portfolio.updatedAt).format("DD/MM/YYYY HH:mm") : null} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography style={{ fontWeight: 600, fontSize: 14, color: "#555", marginBottom: 4 }}>
              Description
            </Typography>
            <Typography style={{ fontSize: 14, marginBottom: 16 }}>
              {portfolio.description || "N/A"}
            </Typography>

            {Array.isArray(portfolio.tags) && portfolio.tags.length > 0 && (
              <Box style={{ marginBottom: 16 }}>
                <Typography style={{ fontWeight: 600, fontSize: 14, color: "#555", marginBottom: 4 }}>Tags</Typography>
                <Box style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                  {portfolio.tags.map((tag, i) => (
                    <Chip key={i} label={tag} size="small" variant="outlined" />
                  ))}
                </Box>
              </Box>
            )}
          </Grid>
        </Grid>

        {/* Cover Images */}
        {coverItems.length > 0 && (
          <Box style={{ marginTop: 16 }}>
            <Typography style={{ fontWeight: 600, fontSize: 14, color: "#555", marginBottom: 8 }}>
              Cover Media ({coverItems.length})
            </Typography>
            <Grid container spacing={2}>
              {coverItems.map((media, i) => (
                <Grid item key={i} xs={6} sm={4} md={3}>
                  <MediaItem media={media} index={i} prefix="cover" />
                </Grid>
              ))}
            </Grid>
          </Box>
        )}

        {/* Media */}
        {mediaItems.length > 0 && (
          <Box style={{ marginTop: 16 }}>
            <Typography style={{ fontWeight: 600, fontSize: 14, color: "#555", marginBottom: 8 }}>
              Media ({mediaItems.length})
            </Typography>
            <Grid container spacing={2}>
              {mediaItems.map((media, i) => (
                <Grid item key={i} xs={6} sm={4} md={3}>
                  <MediaItem media={media} index={i} prefix="media" />
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default ViewPortfolio;
